<div class="tt-root">

  <!-- ═════════ HERO ═════════ -->
  <section class="tt-hero" id="home">
    <div class="tt-wrap tt-hero-grid">
      <div class="tt-hero-copy">
        <span class="tt-badge"><i class="ti ti-calendar-stats"></i> Weekly 11+ topic tests, October to February</span>
        <h1 class="tt-h1">Master the 11+, One Topic Test at a Time!</h1>
        <p class="tt-hero-p">15 Weeks of Targeted Practice, Detailed Feedback & Exam Confidence.</p>
        <div class="tt-hero-btns">
          <a class="tt-btn tt-btn-gold" href="#calendar-section" (click)="scrollTo('calendar-section', $event)"><i class="ti ti-ticket"></i> Book a topic test</a>
          <a class="tt-btn tt-btn-ghost" href="#" (click)="downloadCalendar($event)"><i class="ti ti-download"></i> Download schedule</a>
        </div>
      </div>

      <div class="tt-guide">
        <p class="tt-guide-title"><i class="ti ti-clipboard-list"></i> What you get over 15 weeks</p>
        <div class="tt-pill" *ngFor="let g of guide">
          <span class="tt-pill-ic"><i class="ti" [ngClass]="g.icon"></i></span>
          <div><b>{{ g.title }}</b><small>{{ g.text }}</small></div>
        </div>
      </div>
    </div>
  </section>

  <!-- ═════════ STATS ═════════ -->
  <div class="tt-wrap">
    <div class="tt-stats">
      <div class="tt-stat" *ngFor="let s of stats">
        <div class="tt-stat-n">{{ s.num }}<span *ngIf="s.suffix">{{ s.suffix }}</span></div>
        <div class="tt-stat-l">{{ s.label }}</div>
      </div>
    </div>
  </div>

  <!-- ═════════ SUBJECTS ═════════ -->
  <section class="tt-sec" id="subjects">
    <div class="tt-wrap">
      <div class="tt-head">
        <span class="tt-tag"><i class="ti ti-books"></i> What we cover</span>
        <h2 class="tt-h2">Step-by-step preparation for 11+ success</h2>
        <p class="tt-lead">Weekly topic tests that help students cover the entire 11+ syllabus, one week at a time.</p>
      </div>
      <div class="tt-subj-grid">
        <div class="tt-subj" *ngFor="let s of subjects">
          <div class="tt-subj-ic"><i class="ti" [ngClass]="s.icon"></i></div>
          <h3>{{ s.title }}</h3>
          <p>{{ s.text }}</p>
        </div>
      </div>
      <div class="tt-note"><i class="ti ti-info-circle"></i><span>Topic tests are a warm-up before the full Mock Test series (March to September), so students can find weak spots early.</span></div>
    </div>
  </section>

  <!-- ═════════ FEATURES ═════════ -->
  <section class="tt-sec tt-features">
    <div class="tt-wrap">
      <div class="tt-head">
        <span class="tt-tag"><i class="ti ti-award"></i> Proven results</span>
        <h2 class="tt-h2">Trusted by parents, loved by students</h2>
        <p class="tt-lead">Alumni parents have recommended our topic tests for years, with many students going on to top 11+ results.</p>
      </div>
      <div class="tt-feat-grid">
        <div class="tt-feat" *ngFor="let f of features">
          <div class="tt-feat-ic"><i class="ti" [ngClass]="f.icon"></i></div>
          <h3>{{ f.title }}</h3>
          <p>{{ f.text }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ═════════ BENEFITS ═════════ -->
  <section class="tt-sec tt-benefits">
    <div class="tt-wrap">
      <div class="tt-head">
        <span class="tt-tag"><i class="ti ti-star"></i> Your advantage</span>
        <h2 class="tt-h2">Your 11+ preparation, organised</h2>
        <p class="tt-lead">More than practice papers: a structured system built around the real exam syllabus.</p>
      </div>
      <div class="tt-ben-grid">
        <div class="tt-ben" *ngFor="let b of benefits">
          <div class="tt-ben-ic"><i class="ti" [ngClass]="b.icon"></i></div>
          <div><h4>{{ b.title }}</h4><p>{{ b.text }}</p></div>
        </div>
      </div>
    </div>
  </section>

  <!-- ═════════ STEPS ═════════ -->
  <section class="tt-sec" id="steps">
    <div class="tt-wrap">
      <div class="tt-head">
        <span class="tt-tag"><i class="ti ti-flag"></i> Get started</span>
        <h2 class="tt-h2">Ready in 3 easy steps</h2>
        <p class="tt-lead">From sign-up to your first test in minutes, with no complex setup.</p>
      </div>
      <div class="tt-steps-row">
        <div class="tt-step" *ngFor="let s of steps; let i = index">
          <div class="tt-step-n">{{ i + 1 }}</div>
          <h3>{{ s.title }}</h3>
          <p>{{ s.text }}</p>
        </div>
      </div>
      <div class="tt-steps-cta">
        <a class="tt-btn tt-btn-gold" href="#calendar-section" (click)="scrollTo('calendar-section', $event)"><i class="ti ti-calendar-event"></i> See test dates</a>
      </div>
    </div>
  </section>

  <!-- ═════════ CALENDAR ═════════ -->
  <section class="tt-cal" id="calendar-section">
    <div class="tt-wrap">
      <div class="tt-head">
        <span class="tt-tag"><i class="ti ti-calendar"></i> Test calendar</span>
        <h2 class="tt-h2">Find a test date and book</h2>
        <p class="tt-lead">Filter by centre, board, month or format, then book your child's seat.</p>
      </div>

      <div class="tt-filters">
        <div class="tt-search">
          <i class="ti ti-search"></i>
          <input type="text" placeholder="Search by test name, centre or exam board"
                 [(ngModel)]="filters.search" (input)="onSearch()" aria-label="Search sessions">
        </div>
        <div class="tt-fgrid">
          <div class="tt-field">
            <label for="ttBoard">Exam board</label>
            <div class="tt-select">
              <select id="ttBoard" [(ngModel)]="filters.pattern" (change)="applyFilters()">
                <option [ngValue]="null">All boards</option>
                <option *ngFor="let p of patternTypes" [ngValue]="p.type_id">{{ p.type }}</option>
              </select>
              <i class="ti ti-chevron-down"></i>
            </div>
          </div>
          <div class="tt-field">
            <label for="ttMode">Format</label>
            <div class="tt-select">
              <select id="ttMode" [(ngModel)]="filters.mode" (change)="applyFilters()">
                <option value="">Both</option>
                <option value="Classroom Session">Face to face</option>
                <option value="Online Session">Online</option>
              </select>
              <i class="ti ti-chevron-down"></i>
            </div>
          </div>
          <div class="tt-field">
            <label for="ttMonth">Month</label>
            <div class="tt-select">
              <select id="ttMonth" [(ngModel)]="filters.month" (change)="applyFilters()">
                <option value="">Any</option>
                <option *ngFor="let m of months" [value]="m.value">{{ m.label }}</option>
              </select>
              <i class="ti ti-chevron-down"></i>
            </div>
          </div>
          <div class="tt-field">
            <label for="ttCentre">Centre</label>
            <div class="tt-select">
              <select id="ttCentre" [(ngModel)]="filters.center" (change)="applyFilters()">
                <option value="">Any</option>
                <option *ngFor="let c of centers" [value]="c">{{ c }}</option>
              </select>
              <i class="ti ti-chevron-down"></i>
            </div>
          </div>
        </div>
        <div class="tt-factions">
          <span class="tt-result" *ngIf="!loading"><b>{{ testList.length }}</b> session{{ testList.length === 1 ? '' : 's' }} found</span>
          <span class="tt-result" *ngIf="loading">Loading sessions…</span>
          <div class="tt-fbtns">
            <button type="button" class="tt-reset" (click)="resetFilters()"><i class="ti ti-refresh"></i> Reset filters</button>
            <a class="tt-dl" href="#" (click)="downloadCalendar($event)"><i class="ti ti-download"></i> Schedule</a>
          </div>
        </div>
      </div>

      <div class="tt-list" *ngIf="!loading && testList.length > 0">
        <article class="tt-row" *ngFor="let t of visibleList; trackBy: trackByIdx" [class.is-range]="t._range">

          <span style="display:none">{{ t.test_name }} {{ t.course }} {{ t.category }} {{ t.type }} {{ t._loc }}</span>

          <!-- Date stub -->
          <div class="tt-date">
            <div class="tt-date-main" *ngIf="t._range">
              <span class="tt-date-from">From</span>
              <span class="tt-date-raw">{{ t._rangeLabel }}</span>
            </div>
            <div class="tt-date-main" *ngIf="!t._range && t._hasDate">
              <span class="tt-date-dow">{{ t._dow }}</span>
              <span class="tt-date-day">{{ t._day }}</span>
              <span class="tt-date-mon">{{ t._mon }}</span>
            </div>
            <div class="tt-date-main" *ngIf="!t._range && !t._hasDate">
              <span class="tt-date-raw">{{ t._rawLabel }}</span>
            </div>
            <div class="tt-codes" *ngIf="t._codes.length">
              <span class="tt-code" *ngFor="let c of t._codes">{{ c }}</span>
            </div>
          </div>

          <!-- Info -->
          <div class="tt-info">
            <div class="tt-info-top">
              <span class="tt-mode" [class.is-online]="t._online">
                <i class="ti" [ngClass]="t._online ? 'ti-world' : 'ti-users'"></i>{{ t._online ? 'Online' : 'Face to face' }}
              </span>
              <span class="tt-centre" *ngIf="!t._online && t._loc" [attr.title]="t._loc">
                <i class="ti ti-map-pin"></i><span>{{ t._locShort }}</span>
              </span>
              <span class="tt-cat">{{ t._catShort }}</span>
            </div>
            <a class="tt-name" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">{{ t._cleanName }}</a>
            <span class="tt-type" *ngIf="t.type">{{ t._typeShort }} format</span>
          </div>

          <!-- Price -->
          <div class="tt-price">
            <small>Price</small>
            <b *ngIf="t.payment_method === 'Free'" class="is-free">Free</b>
            <b *ngIf="t.payment_method !== 'Free'">£{{ t.test_fees }}</b>
          </div>

          <!-- Book -->
          <div class="tt-act">
            <a class="tt-book" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">Book seat</a>
          </div>
        </article>
      </div>

      <div class="tt-more" *ngIf="!loading && hasMore">
        <button type="button" (click)="loadMore()">Load more sessions</button>
      </div>

      <div class="tt-empty" *ngIf="!loading && testList.length === 0">
        <i class="ti ti-calendar-off"></i>
        <h4>No sessions match these filters</h4>
        <p>Try another month or centre, or reset the filters.</p>
      </div>
    </div>
  </section>

  <!-- ═════════ TESTIMONIALS ═════════ -->
  <section class="tt-sec tt-testi">
    <div class="tt-wrap">
      <div class="tt-head">
        <span class="tt-tag"><i class="ti ti-heart"></i> What parents say</span>
        <h2 class="tt-h2">Trusted by families across the UK</h2>
      </div>
      <div class="tt-testi-grid">
        <div class="tt-tcard" *ngFor="let t of testimonials">
          <div class="tt-stars"><i class="ti ti-star-filled" *ngFor="let s of starCount"></i></div>
          <p>{{ t.text }}</p>
          <div class="tt-author">
            <span class="tt-av">{{ t.initial }}</span>
            <div><b>{{ t.name }}</b><small>{{ t.place }}</small></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ═════════ FAQ ═════════ -->
  <section class="tt-faq">
    <div class="tt-wrap">
      <div class="tt-head">
        <span class="tt-tag"><i class="ti ti-help-circle"></i> FAQs</span>
        <h2 class="tt-h2">Questions parents ask</h2>
      </div>
      <div class="tt-faq-list">
        <details *ngFor="let f of faqs">
          <summary>{{ f.q }} <i class="ti ti-plus"></i></summary>
          <p>{{ f.a }}</p>
        </details>
      </div>

      <div class="tt-contact">
        <div>
          <h4>Still have questions?</h4>
          <p>Talk to our team directly.</p>
        </div>
        <div class="tt-contact-links">
          <a class="tt-clink" href="tel:+447464772331"><i class="ti ti-phone"></i> +44 7464 772331</a>
          <a class="tt-clink" href="mailto:academy@sehyog.co.uk"><i class="ti ti-mail"></i> academy@sehyog.co.uk</a>
        </div>
      </div>
    </div>
  </section>

  <!-- ═════════ CTA ═════════ -->
  <section class="tt-cta">
    <div class="tt-wrap">
      <h2>Start your 11+ journey today</h2>
      <p>Register now and get access to your first weekly topic test.</p>
      <div class="tt-hero-btns">
        <a class="tt-btn tt-btn-gold" href="#calendar-section" (click)="scrollTo('calendar-section', $event)"><i class="ti ti-ticket"></i> Register for topic tests</a>
        <a class="tt-btn tt-btn-ghost" href="#" (click)="downloadCalendar($event)"><i class="ti ti-download"></i> Download schedule</a>
      </div>
    </div>
  </section>

</div>
